import "./index.scss";

const About = () => {
  return (
    <>
      <div align="center">
        <h1>About Us</h1>
      </div>
    </>
  );
};

export default About;
